import { useMemo } from 'react';

import { Payment, Request } from '../types';

export const usePaymentStatus = (request: Request): boolean => {
  const hasCompletedPayments = useMemo(
    () =>
      request.payments?.some(
        (payment: Payment) => payment.executedAt !== undefined,
      ) || false,
    [request.payments],
  );

  return hasCompletedPayments;
};
